import { gql } from "@apollo/client";

export const LOAD_RESERVATION_OFFER_RATE_PLAN = gql`
  mutation loadReservationOffer(
    $loadReservationOfferInput: LoadReservationOfferInput!
    $from: Date!
    $until: Date!
  ) {
    loadReservationOffer(input: $loadReservationOfferInput) {
      reservationOffer {
        accommodations {
          id
          ratePlan {
            id
            name
            isAvailable(from: $from, until: $until)
            description
            occupancy
            mealType
            rateSellMode
            isArchived
            lowestPrice(from: $from, until: $until)
            defaultPriceBreakdown(until: $until, from: $from) {
              discountPercentage
              withoutDiscount
              withDiscount
            }
          }
        }
      }
    }
  }
`;
